import { emptyStateMessages } from 'src/utils/properties.utils';
import NoData from 'src/assets/images/NoData.png';
import {
  StyledEmptyStateContainer,
  StyledEmptyStateImage,
  StyledEmptyStateTitle,
  StyledEmptyStateSubtitle,
} from './StyledEmptyState';

const CustomNoRowsOverlay = () => {
  return (
    <StyledEmptyStateContainer>
      <StyledEmptyStateImage src={NoData} alt="No Data" />
      <StyledEmptyStateTitle>
        {emptyStateMessages.NO_DATA_TITLE}
      </StyledEmptyStateTitle>
      <StyledEmptyStateSubtitle>
        {emptyStateMessages.NO_DATA_SUBTITLE}
      </StyledEmptyStateSubtitle>
    </StyledEmptyStateContainer>
  );
};

export default CustomNoRowsOverlay;
